<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('FinanceManage.ModifyChargeExpirationDate')"
    width="400px"
    :close-on-click-modal="false"
  >
    <el-form label-width="120px" label-position="left">
      <el-form-item :label="$t('Billing.DueDate')">
        <el-date-picker v-model="dueDate" type="date" no="dueDate" value-format="yyyy-MM-dd" style="width:195px;" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" no="ok" @click="ok">{{ $t('common.btn.ok') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'UpdateDueDateDialog',
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      dueDate: null
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.dueDate = null
      }
    }
  },
  methods: {
    ok() {
      if (!this.dueDate) {
        this.$message.warning(this.$t('Billing.DueDate') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      this.$emit('returnCall', this.dueDate)
      this.innerVisible = false
    }
  }
}
</script>
